import G6 from '@antv/g6';
import { ModelConfig } from '@antv/g6';

import { setItemState } from 'components/Visualization/Graphs/nodes/setItemState';

import { colors } from '../../../../../theme/theme2/colors';

import { PORT_NODE } from './nodes_types';

export function registerPortNode() {
  G6.registerNode(
    PORT_NODE,
    {
      setState(name, value, item) {
        setItemState(name, value, item);
      },
      //@ts-ignore
      draw(cfg?: ModelConfig, group?: IGroup) {
        const container = group.addShape(
          'circle',
          {
            attrs: {
              x: 30,
              y: 30,
              fill: colors.black,
              shadowColor: '#999',
              shadowBlur: 21,
              shadowOffsetY: 10,
              opacity: 1,
              r: 20,
            },
          },
          'container',
        );

        const { x = 0, y = 0, width = 0, height = 0 } = container.getBBox();

        group.addShape('text', {
          attrs: {
            x: x + 20,
            y: y + 27,
            textAlign: 'center',
            textBaline: 'middle',
            // @ts-ignore
            text: cfg?.data?.port || '22', // cfg.data : typescript throws Object is of type 'unknow'
            fontSize: 14,
            opacity: 1,
            fill: colors.white,
            cursor: 'pointer',
          },
          name: 'id',
        });

        group.addShape('text', {
          attrs: {
            x: x + 20,
            y: height + 30 + 10,
            textAlign: 'center',
            // @ts-ignore
            text: 'Port', // cfg.data : typescript throws Object is of type 'unknow'
            fontSize: 12,
            // fontStyle: 'bold',
            opacity: 1,
            fill: colors.black,
            cursor: 'pointer',
          },
          name: 'guid',
        });

        return container;
      },
      getAnchorPoints(cfg) {
        return [
          [0, 0.5],
          [1, 0.5],
        ];
      },
    },

    'rect',
  );
}
